export const PROJECT = 'PROJECT'
export const PRODUCT = 'PRODUCT'
export const TRACK = 'TRACK'
export const DEAL = 'DEAL'
export const PUBLISHER = 'PUBLISHER'
export const PUBLISHER_MAPPING = 'PUBLISHER_MAPPING'
